if (!customElements.get("product-option-dropdown")) {
  class ProductOptionDropdown extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.init();
      this.initialized = true;
    }

    init() {
      this.select = this.querySelector("select");
      this.trigger = this.querySelector(".product-option-dropdown__trigger");
      this.text = this.querySelector(".product-option-dropdown__text");
      this.list = this.querySelector(".product-option-dropdown__list");
      this.options = this.querySelectorAll(".product-option-dropdown__item");

      if (!this.select || !this.trigger) return;

      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onTriggerKeydown = this.onTriggerKeydown.bind(this);
      this.onOptionClick = this.onOptionClick.bind(this);
      this.onWindowClick = this.onWindowClick.bind(this);

      this.trigger.addEventListener("click", this.onTriggerClick);
      this.trigger.addEventListener("keydown", this.onTriggerKeydown);

      document.addEventListener("click", this.onWindowClick);

      this.options.forEach((opt) => {
        opt.addEventListener("click", (e) => this.onOptionClick(e, opt));

        opt.addEventListener("keydown", (e) => this.onOptionKeydown(e, opt));
      });
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.onWindowClick);
    }

    onTriggerClick(e) {
      e.stopPropagation();
      e.preventDefault();
      this.toggle();
    }

    onTriggerKeydown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.toggle();
      }
    }

    onOptionClick(e, option) {
      e.stopPropagation();
      this.selectValue(option);
    }

    onOptionKeydown(e, option) {
      if (e.key === "Enter") {
        e.preventDefault();
        this.selectValue(option);

        this.trigger.focus();
      }
    }

    toggle() {
      const isOpen = this.classList.contains("is-open");

      document.querySelectorAll("product-option-dropdown").forEach((el) => {
        if (el !== this) el.close();
      });

      if (isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    selectValue(option) {
      const value = option.getAttribute("data-value");

      this.select.value = value;
      this.text.textContent = option.textContent.trim();

      this.options.forEach((o) => {
        o.classList.remove("is-selected");
        o.setAttribute("aria-selected", "false");
      });
      option.classList.add("is-selected");
      option.setAttribute("aria-selected", "true");

      this.select.dispatchEvent(new Event("change", { bubbles: true }));

      this.close();
    }

    onWindowClick(e) {
      if (!this.contains(e.target) && this.classList.contains("is-open")) {
        this.close();
      }
    }

    open() {
      this.classList.add("is-open");
      this.trigger.setAttribute("aria-expanded", "true");
    }

    close() {
      this.classList.remove("is-open");
      this.trigger.setAttribute("aria-expanded", "false");
    }
  }

  customElements.define("product-option-dropdown", ProductOptionDropdown);
}
